import { ExternalService, ExternalServiceField, ExternalServiceEntry, IUser, ExternalServiceEntries } from '___types'

import API from './api'
import { auth as firebaseAuth } from 'utils'

class User extends API {
  public constructor() {
    super('users/')
  }

  public getUser = async (publicFlow: boolean = false) => {
    if (publicFlow) return
    const res = await this.get('me', undefined, 'v1')
    // /////////////////////////////////////////////////////////////////////////// //
    // ///////////////////////////// V3 ROLLOUT TODO ///////////////////////////// //
    // /////////////////////////////////////////////////////////////////////////// //
    // remove parsing when BE changes field names
    const user = res.data.data.user
    Object.assign(user, { subscriptions: user.subs })
    delete user.subs
    Object.assign(user.privacy, { docxDownload: user.privacy.wordDownload })
    delete user.privacy.wordDownload
    return user as IUser
    // /////////////////////////////////////////////////////////////////////////// //
    // /////////////////////////////////////////////////////////////////////////// //
    // /////////////////////////////////////////////////////////////////////////// //
    // return res.data as IUser
  }

  public getExternalApiFields = async () => {
    const res = await this.get('external/services/fields', undefined, 'v1')
    // /////////////////////////////////////////////////////////////////////////// //
    // ///////////////////////////// V3 ROLLOUT TODO ///////////////////////////// //
    // /////////////////////////////////////////////////////////////////////////// //
    // remove parsing when response fixes service structure
    const services = res?.data?.data?.services || []
    const parsedServices = services?.map(
      ({ service: { id, title }, list }: { service: { id: string; title: string }; list: ExternalServiceField }) => ({ id, title, fields: list })
    )
    return parsedServices as ExternalService[]
    // /////////////////////////////////////////////////////////////////////////// //
    // /////////////////////////////////////////////////////////////////////////// //
    // /////////////////////////////////////////////////////////////////////////// //
    // return res.data.data.services as ExternalService[]
  }

  public getExternalApiEntries = async (service: string) => {
    const res = await this.post(`external/services/entries`, { serviceId: service }, undefined, 'v1')
    const entries = res?.data || {}
    return entries as ExternalServiceEntries
  }

  public getExternalApiEntry = async (service: string, id: string, fields: string) => {
    if (!(service && id)) return
    const res = await this.post(`external/services/entries/${id}`, { serviceId: service, fields: fields.split('; ') }, undefined, 'v1')
    return res?.data?.data as ExternalServiceEntry
  }

  public setAuthHeaders = (token: string, expirationTime: string) => {
    localStorage.setItem('casusToken', token)
    localStorage.setItem('casusExpiresIn', expirationTime)
  }

  public removeAuthHeaders = () => {
    localStorage.removeItem('casusToken')
    localStorage.removeItem('casusExpiresIn')
  }

  public logoutUser = async () => await firebaseAuth.signOut().finally(() => this.removeAuthHeaders())
}

export const userAPI = new User()

export default userAPI
